import React from "react";

export default function Alert({ loading, message }) {
  return (
    <div
      className={`transition-all ease-linear duration-150 w-full font-sans rounded-lg text-[#C00000] font-semibold py-1 px-4 flex items-center justify-center mb-2 ${
        loading ? "h-10 opacity-100" : "h-0 opacity-0"
      }`}
    >
      {message}
    </div>
  );
}
